
import { Link } from 'react-router-dom';

const ProfessionalNav = () => {
  const categories = [
    {
      title: 'Artisans',
      icon: 'ri-tools-line',
      description: 'Gestion client, outils administratifs et référencement',
      link: '/professionnels/artisans',
      image: 'https://public.readdy.ai/ai/img_res/68625e64919ab08f8303a62477828c37.jpg',
    },
    {
      title: 'TPE / PME',
      icon: 'ri-building-2-line',
      description: 'Externalisation, audit commercial et formations',
      link: '/professionnels/tpe-pme',
      image: 'https://readdy.ai/api/search-image?query=Dynamic%20small%20business%20team%20meeting%20in%20modern%20office%20space%2C%20collaborative%20work%20environment%2C%20professional%20business%20setting%20with%20laptops%20and%20documents%2C%20bright%20natural%20lighting%2C%20corporate%20photography%20style%20showing%20teamwork%20and%20productivity&width=600&height=400&seq=prof-tpe-001&orientation=landscape',
    },
    {
      title: 'Libéraux',
      icon: 'ri-stethoscope-line',
      description: 'Secrétariat externalisé et assistance directionnelle',
      link: '/professionnels/liberaux',
      image: 'https://readdy.ai/api/search-image?query=Professional%20liberal%20profession%20office%20with%20modern%20consultation%20space%2C%20organized%20medical%20or%20legal%20practice%20environment%2C%20clean%20professional%20setting%20with%20desk%20and%20comfortable%20seating%2C%20natural%20lighting%2C%20high-end%20professional%20photography&width=600&height=400&seq=prof-liberal-001&orientation=landscape',
    },
    {
      title: 'Micro-entrepreneur',
      icon: 'ri-user-star-line',
      description: 'Formation adaptée et réseau local',
      link: '/professionnels/micro-entrepreneur',
      image: 'https://readdy.ai/api/search-image?query=Young%20French%20micro-entrepreneur%20working%20in%20flexible%20coworking%20space%20with%20laptop%20and%20smartphone%2C%20modern%20nomadic%20work%20environment%2C%20bright%20and%20inspiring%20workspace%2C%20professional%20lifestyle%20photography%20showing%20independence%20and%20entrepreneurship&width=600&height=400&seq=prof-micro-001&orientation=landscape',
    },
    {
      title: 'Cadres',
      icon: 'ri-user-settings-line',
      description: 'Formation managériale et développement de réseau',
      link: '/professionnels/cadres',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20executive%20presenting%20strategy%20in%20modern%20conference%20room%2C%20leadership%20and%20management%20setting%2C%20corporate%20professional%20environment%20with%20presentation%20screen%2C%20high%20quality%20business%20photography%20showing%20authority%20and%20expertise&width=600&height=400&seq=prof-cadre-001&orientation=landscape',
    },
    {
      title: 'Dirigeants',
      icon: 'ri-shield-star-line',
      description: 'Conseil stratégique et gouvernance',
      link: '/professionnels/dirigeants',
      image: 'https://readdy.ai/api/search-image?query=Senior%20business%20leader%20in%20executive%20boardroom%20setting%2C%20strategic%20business%20meeting%20environment%2C%20luxury%20corporate%20office%20with%20modern%20furniture%2C%20professional%20handshake%20and%20business%20partnership%2C%20high-end%20corporate%20photography%20showing%20leadership%20and%20vision&width=600&height=400&seq=prof-dirigeant-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary-dark mb-4">
            Choisissez votre profil
          </h2>
          <p className="text-lg text-gray-dark max-w-2xl mx-auto">
            Des solutions spécifiques pour chaque type d'activité professionnelle
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <Link
              key={index}
              to={category.link}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-xl">
                  <i className={`${category.icon} text-2xl text-primary`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-primary-dark mb-3 group-hover:text-primary transition-colors">
                  {category.title}
                </h3>
                <p className="text-base text-gray-dark leading-relaxed">
                  {category.description}
                </p>
                <div className="mt-4 flex items-center gap-2 text-primary font-semibold text-sm">
                  En savoir plus
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProfessionalNav;
